import QuickQuoteService from './services/QuickQuoteService';
import QuickQuoteLink from 'integration/quoteandbind/quickquote/directives/QuickQuoteLink';
import 'edge/quoteandbind/util/app';

export default angular.module('edge.quoteandbind.quickquote.common.app', ['edge.quoteandbind.util.app'])
    .factory('quickquote.QuickQuoteService', QuickQuoteService)
    .directive('gwQuickQuoteLink', QuickQuoteLink);
